import React, {useEffect, useState} from 'react';
import Backdrop from "@mui/material/Backdrop";
import {Box, Fade, IconButton, Modal, Typography} from "@mui/material";
import {file, menu, moneyT,} from "../translate";
import Api from "../Api";
import MoneyChange from "./MoneyChange";
import CloseIcon from '@mui/icons-material/Close';
import {greenTheme, style} from "../helpers/style";


function Money({open, setOpen}) {
    const primaryColor = process.env.REACT_APP_SERVER === 'ATS' ? '#0973b9' : greenTheme.primary;
    const [money, setMoney] = useState([])
    const [number, setNumber] = useState(0)
    const [change, setChange] = useState(false)
    const [discount, setDiscount] = useState(0)
    const [total_auto, setTotal_auto] = useState(0)
    useEffect(() => {
        (async () => {
            try {
                const {data} = await Api.money()
                setMoney(data.mappedData)
                setNumber(data.ggumar)
                setDiscount(data.discounted)
                setTotal_auto(data.total_auto)
            } catch (e) {

            }
        })()
    }, [])
    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={() => setOpen(false)}
            closeAfterTransition
            slots={{backdrop: Backdrop}}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box sx={{...style, position: 'relative', borderRadius: '12px', overflow: 'visible'}}>
                    <IconButton
                        onClick={() => setOpen(false)}
                        aria-label="Close"
                        sx={{
                            position: 'absolute',
                            right: -56,
                            top: 24,
                            zIndex: 1,
                            width: 56,
                            height: 40,
                            borderRadius: '0 12px 12px 0',
                            backgroundColor: primaryColor,
                            color: '#fff',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                            '&:hover': {backgroundColor: primaryColor, opacity: 0.9, color: '#fff'},
                        }}
                    >
                        <CloseIcon sx={{fontSize: 20}}/>
                    </IconButton>
                    <div className="d-flex flex-row justify-content-between">
                        <Typography id="transition-modal-title" variant="h6" component="h2">
                            {menu.amount[+localStorage.getItem('atsLang')  || 1]}
                        </Typography>
                    </div>
                    <Box
                        sx={{
                            maxHeight: 'calc(90vh - 150px)',
                            overflowY: 'auto',
                            pr: 1,
                            '&::-webkit-scrollbar': {width: '6px'},
                            '&::-webkit-scrollbar-track': {background: 'transparent'},
                            '&::-webkit-scrollbar-thumb': {
                                background: '#cbd5e1',
                                borderRadius: '8px',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                                background: '#94a3b8',
                            },
                            scrollbarWidth: 'thin',
                            scrollbarColor: '#cbd5e1 transparent',
                        }}
                    >
                        <table style={{width: '100%'}}>
                            <thead align="center">
                            <tr style={{padding: '10px 15px'}}
                            >
                                <th style={{textAlign: 'center',padding: '10px 15px'}}>
                                    {moneyT.name[+localStorage.getItem('atsLang')  || 1]}
                                </th>
                                <th style={{textAlign: 'center',padding: '10px 15px'}}>
                                    {moneyT.act[+localStorage.getItem('atsLang')  || 1]}
                                </th>
                                <th style={{textAlign: 'center',padding: '10px 15px'}}>
                                    {moneyT.money[+localStorage.getItem('atsLang')  || 1]}
                                </th>
                            </tr>
                            </thead>
                            <tbody align="center">
                            {money?.map((m, _) => (
                                <tr  key={_}>
                                    <td align="center" style={{padding: '10px 15px'}}>
                                        {moneyT[m.name][+localStorage.getItem('atsLang')  || 1]}
                                    </td>
                                    <td align="center" style={{padding: '10px 15px'}}>
                                        {m.act}

                                    </td>
                                    <td align="center" style={{padding: '10px 15px'}}>
                                        {m.gumar} / {m.gumar - m.discount}

                                    </td>
                                </tr>
                            )) }
                            <tr >
                                    <td align="center" style={{padding: '10px 15px'}}>
                                        {moneyT.autoCall[+localStorage.getItem('atsLang')  || 1]}
                                    </td>
                                    <td align="center" style={{padding: '10px 15px'}}>
                                        {total_auto}

                                    </td>
                                    <td align="center" style={{padding: '10px 15px'}}>
                                        0 / {total_auto * 10}

                                    </td>
                                </tr>

                            <tr>
                                <th colSpan={2} style={{padding: '10px 15px',textAlign: 'right'}} align='right'/>
                                <th style={{padding: '10px 15px', textAlign: 'center'}}>{number} / {discount + total_auto * 10}</th>
                            </tr>
                            <tr>
                                <th colSpan={3} style={{textAlign: 'right'}} align='right'><hr className="m-0"/></th>
                            </tr>
                            <tr>
                                <td colSpan={3} onClick={() => setChange(true)} style={{padding: '10px 15px',textAlign: 'right', cursor:'pointer'}}>
                                    {moneyT.history[+localStorage.getItem('atsLang')  || 1]}
                                </td>
                            </tr>

                            </tbody>
                        </table>
                    </Box>
                    {change?<MoneyChange open={change} setOpen={setChange}/>:null}
                </Box>
            </Fade>
        </Modal>
    );
}

export default Money;
